<template>
  <div class="el-col-24">
    <h5 class="warp-title">留言管理</h5>
    <el-form :inline="true" :model="searchForm" size="small" class="search">
      <el-form-item label="平台类型">
        <el-select v-model="searchForm.platformType" placeholder="请选择显示" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option :label="item.name" :value="item.id" v-for="(item, index) in platformList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理状态">
        <el-select v-model="searchForm.handerStatus" placeholder="请选择处理状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="待分配" :value="1"></el-option>
          <el-option label="待处理" :value="2"></el-option>
          <el-option label="处理中" :value="3"></el-option>
          <el-option label="已完成" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="账号">
        <el-input v-model="searchForm.platformAccount" placeholder="请输入平台账号"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="searchForm.phone" placeholder="请输入用户手机号"></el-input>
      </el-form-item>
      <el-form-item label="留言时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="留言开始日期"
          end-placeholder="留言结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" v-if="querybtn.note_serch === 1" :loading="isSearchLoading">查询</el-button>
        <el-button @click="export1" v-if="querybtn.note_export === 1" :loading="isExportLoading">导出</el-button>
      </el-form-item>
    </el-form>
    <!-- 操作区域 -->
    <HandleArea :querybtn="querybtn" />
    <!-- 表格数据 -->
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="id" label="ID" align="center" width="60"></el-table-column>
      <el-table-column label="平台类型" align="center">
        <template slot-scope="scope">
          <span>{{ $getPlatformName(scope.row.platformType) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="platformAccount" label="平台账号" align="center"></el-table-column>
      <el-table-column label="手机号" align="center">
        <template slot-scope="scope">
          {{ scope.row.encryptionPhone }}
          <p class="cursor blue" @click="seePhone(scope.row.phone)" v-if="searchForm.phoneViewStatus === 0">查看</p>
        </template>
      </el-table-column>
      <el-table-column prop="noteTime" label="留言时间" align="center"></el-table-column>
      <el-table-column label="留言信息" align="center" width="500">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="light" :content="scope.row.noteInfo" placement="top">
            <span class="note-info cursor">{{scope.row.noteInfo}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="跟进人" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.handerPeopleName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="处理状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="getHandleStatus(scope.row.handerStatus)" size="medium" :type="getHandleStatus(scope.row.handerStatus).color">{{getHandleStatus(scope.row.handerStatus).name}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-link :underline="false" type="primary" v-if="querybtn.note_distribution === 1 && scope.row.handerStatus === 1" @click="openDistribution(scope.row)">去分配</el-link>
          <!-- 有处理权限+待处理 -->
          <el-link :underline="false" type="primary" v-if="querybtn.note_hander === 1 && scope.row.handerStatus === 2" @click="toHandle(scope.row, 3)">去处理</el-link>
          <el-link :underline="false" type="primary" v-if="querybtn.note_detail === 1" @click="toHandle(scope.row)">查看详情</el-link>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      align="right"
      class="mt20"
      background>
    </el-pagination>
    <el-dialog
      title="留言分配"
      :visible.sync="showDistribution"
      width="30%">
        <el-form ref="distributionForm" :model="distributionForm" label-width="80px" class="distribution-box" :rules="distributionFormRules">
          <el-form-item label="指派给" prop="userId">
            <el-select v-model="distributionForm.userId" placeholder="请选择">
              <el-option v-for="(item, index) in customerList" :key="index" :label="item.customerName" :value="item.userId">
              </el-option>
            </el-select>
            <!-- <el-input v-model="distributionForm.userId"></el-input> -->
          </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDistribution = false">取 消</el-button>
        <el-button type="primary" @click="submitDistribution" :loading="distributionLoading">确认分配</el-button>
      </span>
    </el-dialog>
    <MessageDetailDrawer :isShow.sync="isDetailShow" :id="currentId" @close="handleCloseDetail" />
  </div>
</template>

<script>
import HandleArea from './HandleArea.vue'
import {queryCustomerList} from '../../api/statistics/index'
import {queryNoteInfoPage, exportNoteInfo, imNoteRecordSetHanderStatus} from '../../api/message/index'
import { queryButtonPermission } from '../../api/public/auth'
import MessageDetailDrawer from './MessageDetailDrawer.vue'
export default {
  name: 'Message',
  async created () {
    this.getCustomerList()
    let data = {
      id: global.$sider
    }
    queryButtonPermission(data).then((info) => {
      if (info.data.resultCode === 0) {
        this.querybtn = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
  },
  components: {
    HandleArea,
    MessageDetailDrawer
  },
  computed: {
    myUserInfo () {
      return this.$store.state.Auth.userInfo
    },
    platformList () {
      return this.$store.state.Auth.platformList
    }
  },
  data () {
    return {
      handleStatusConfig: [
        {
          name: '待分配',
          value: 1,
          color: 'danger'
        },
        {
          name: '待处理',
          value: 2,
          color: 'warning'
        },
        {
          name: '处理中',
          value: 3,
          color: 'warning'
        },
        {
          name: '已完成',
          value: 4,
          color: 'success'
        }
      ],
      currentId: '',
      isDetailShow: false,
      distributionFormRules: {
        userId: [
          {required: true, message: '请选择分配的客服', trigger: 'blur'}
        ]
      },
      distributionLoading: false,
      distributionForm: {
        handerStatus: 2,
        id: '',
        userId: ''
      },
      customerList: [],
      showDistribution: false,
      isExportLoading: false,
      isSearchLoading: false,
      querybtn: {},
      searchForm: {
        platformType: '',
        handerStatus: '',
        platformAccount: '',
        phone: '',
        startTime: '',
        endTime: '',
        currentPage: 1,
        pageSize: 10,
        phoneViewStatus: global.$siderItem.phoneViewStatus
      },
      time: [],
      total: 0,
      tableData: [],
      detail: {},
      detailBox: false
    }
  },
  watch: {
    time (time) {
      if (time && time.length > 0) {
        this.searchForm.startTime = time[0]
        this.searchForm.endTime = time[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    }
  },
  methods: {
    getHandleStatus (value) {
      let item = this.handleStatusConfig.find(item => item.value === value)
      return item || null
    },
    // 关闭详情
    handleCloseDetail () {
      this.isDetailShow = false
      this.initData()
    },
    // 查看手机号
    seePhone (phone) {
      this.$alert(phone, '提示', {showConfirmButton: false})
    },
    submitDistribution () {
      this.$refs.distributionForm.validate(res => {
        if (res) {
          this.distributionLoading = true
          imNoteRecordSetHanderStatus(this.distributionForm).then(res => {
            this.distributionLoading = false
            if (res.data.resultCode === 0) {
              this.$message.success('分配成功')
              this.showDistribution = false
              this.onSubmit()
            } else {
              this.$message.error(res.data.resultMessage)
            }
          }).catch(() => {
            this.distributionLoading = false
          })
        }
      })
    },
    openDistribution (item) {
      this.distributionForm.id = item.id
      this.showDistribution = true
    },
    getCustomerList () {
      queryCustomerList().then(res => {
        if (res.data.resultCode === 0) {
          this.customerList = res.data.resultData
        } else {
          this.$message.error(res.data.resultMessage)
        }
      })
    },
    toHandle (item, handerStatus) {
      if (handerStatus) {
        let data = {
          handerStatus: handerStatus,
          id: item.id
        }
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        imNoteRecordSetHanderStatus(data).then(res => {
          loading.close()
          if (res.data.resultCode === 0) {
            // this.$router.push({
            //   name: 'MessageDetail',
            //   params: {
            //     id: item.id
            //   }
            // })
            this.currentId = item.id
            this.isDetailShow = true
          } else {
            this.$message(res.data.resultMessage)
          }
        }).catch(() => {
          loading.close()
        })
      } else {
        this.currentId = item.id
        this.isDetailShow = true
        // this.$router.push({
        //   name: 'MessageDetail',
        //   params: {
        //     id: item.id
        //   }
        // })
      }
    },
    export1 () {
      let params = {
        ...this.searchForm,
        phoneExportStatus: global.$siderItem.phoneExportStatus
      }
      delete params['currentPage']
      delete params['pageSize']
      delete params['phoneViewStatus']
      this.isExportLoading = true
      exportNoteInfo(params).then(res => {
        this.isExportLoading = false
        if (res.data.resultCode === 0) {
          window.open(res.data.resultData.fileDownLoadUrl)
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).catch(() => {
        this.isExportLoading = false
      })
    },
    initData () {
      this.isSearchLoading = true
      queryNoteInfoPage(this.searchForm).then(res => {
        this.isSearchLoading = false
        if (res.data.resultCode === 0) {
          this.tableData = res.data.resultData
          this.total = res.data.totalCount
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).catch(() => {
        this.isSearchLoading = false
      })
    },
    onSubmit () {
      this.searchForm.currentPage = 1
      this.initData()
    },
    handleSizeChange (size) {
      this.searchForm.pageSize = size
      this.searchForm.currentPage = 1
      this.initData()
    },
    handleCurrentChange (current) {
      this.searchForm.currentPage = current
      this.initData()
    }
  }
}
</script>

<style lang="less" scoped>
.note-info{
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
/deep/tr.el-table__row td{
  text-align: center;
}
.info-container{
  max-height: 450px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Message/Index.vue